export default "__VITE_ASSET__6ywt8w99__";